import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { Check } from './icons';
import { colors, spacing } from '../theme/tokens';

export interface FriseEtapesProps {
  etapes: readonly string[];
  // Indice (à partir de 0) de l'étape en cours : celles d'avant sont validées, celles d'après attendent.
  etape: number;
  testID?: string;
}

/**
 * Frise « 1 Importe, 2 L'IA évalue, 3 Ton score » en tête des outils. Elle situe la personne, elle
 * ne se touche pas : une seule phrase au lecteur d'écran, « 2/3, L'IA évalue ».
 */
export function FriseEtapes({ etapes, etape, testID }: FriseEtapesProps) {
  return (
    <View
      testID={testID}
      accessible
      accessibilityLabel={`${etape + 1}/${etapes.length}, ${etapes[etape]}`}
      style={styles.frise}
    >
      {etapes.map((libelle, i) => {
        const validee = i < etape;
        const active = i === etape;
        return (
          <React.Fragment key={libelle}>
            {i > 0 ? (
              <View
                testID={testID ? `${testID}-trait-${i - 1}` : undefined}
                style={[styles.trait, { backgroundColor: i <= etape ? colors.success : colors.bordureClaire }]}
              />
            ) : null}
            <View style={styles.etape}>
              <View
                testID={testID ? `${testID}-pastille-${i}` : undefined}
                style={[
                  styles.pastille,
                  { backgroundColor: validee ? colors.success : active ? colors.night : colors.grey100 },
                ]}
              >
                {validee ? (
                  <View testID={testID ? `${testID}-coche-${i}` : undefined}>
                    <Check size={13} color={colors.white} strokeWidth={3} />
                  </View>
                ) : (
                  <Text style={[styles.numero, { color: active ? colors.white : colors.grey500 }]}>{i + 1}</Text>
                )}
              </View>
              <Text style={[styles.libelle, active || validee ? styles.libelleActif : styles.libelleAttente]}>
                {libelle}
              </Text>
            </View>
          </React.Fragment>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  frise: { flexDirection: 'row', alignItems: 'center', gap: spacing.sm },
  etape: { flexShrink: 1, flexDirection: 'row', alignItems: 'center', gap: spacing.xs + 2 },
  pastille: { width: 22, height: 22, borderRadius: 11, alignItems: 'center', justifyContent: 'center' },
  numero: { fontSize: 12, fontWeight: '800' },
  libelle: { flexShrink: 1, fontSize: 12.5 },
  libelleActif: { fontWeight: '800', color: colors.night },
  libelleAttente: { fontWeight: '600', color: colors.grey500 },
  trait: { flexGrow: 1, minWidth: spacing.md, height: 2, borderRadius: 1 },
});
